import api from '../api';

export const getResumoMensal = async (ano, mes) => {
    try {
        const response = await api.post('/calendar/summary', { ano, mes });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getDetalhesDia = async (data) => {
    try {
        const response = await api.post('/calendar/details', { data });
        return response.data;
    } catch (error) {
        throw error;
    }
};
